import {
  FETCH_AUCTIONS,
  FETCH_AUCTIONS_SUCCESS,
  FETCH_AUCTIONS_FAILED
} from '../../types';

const initialState = {
  auctions: {},
  isLoading: false,
  errors: {},
  error: false
}

const fetchAuctionsReducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_AUCTIONS:
      return {
        ...state,
        isLoading: true,
          auctions: action.payload
      }
      case FETCH_AUCTIONS_SUCCESS:
        return {
          ...state,
          isLoading: false,
            auctions: action.payload
        }
        case FETCH_AUCTIONS_FAILED:
          return {
            ...state,
            isLoading: false,
              errors: action.payload,
              error: true
          }
          default:
            return {
              ...state
            };
  }
}

export default fetchAuctionsReducer;
